import { render, staticRenderFns } from "./UserAuthentication.vue?vue&type=template&id=7c033d80&scoped=true"
import script from "./UserAuthentication.ts?vue&type=script&lang=ts&external"
export * from "./UserAuthentication.ts?vue&type=script&lang=ts&external"
import style0 from "./UserAuthentication.scss?vue&type=style&index=0&id=7c033d80&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c033d80",
  null
  
)

export default component.exports